/* eslint-disable camelcase */

import { valueFormatted, distanceLocalized, durationLocalized, travelTimeLocalized } from '../../utils/travels'
import { mdiAlarm, mdiAxisArrow, mdiKabaddi, mdiMapMarkerDistance, mdiRocket, mdiSleep, mdiSpeedometer } from '@mdi/js'

export class CalendarTravelEntry {
  constructor ({ datetimestart = Date.now(), distance = 0, average_speed = 0.0, max_speed = 0.0, max_acceleration = 0.0, duration = 0, distraction_count = 0, drowsiness_count = 0 } = {}) {
    this.averageSpeed = average_speed
    this.maxSpeed = max_speed
    this.maxAcceleration = max_acceleration
    this.duration = duration
    this.datetimestart = new Date(datetimestart)
    this._distance = distance
    this.distractionCount = distraction_count
    this.drowsinessCount = drowsiness_count
  }

  get distance () {
    return this._distance / 1000.0
  }

  get distanceLocalized () {
    return distanceLocalized(this.distance)
  }

  get formattedTime () {
    return travelTimeLocalized(this.datetimestart)
  }

  get durationLocalized () {
    return durationLocalized(this.duration)
  }

  isEmpty () {
    return this.datetimestart.getTime() === new Date(0).getTime()
  }

  get tripStyle () {
    const distance = this.distance
    const events = this.distractionCount + this.drowsinessCount
    let result = 'green'

    if (distance > 0) {
      const ratio = events / distance
      if (ratio >= 0 && ratio <= 1) {
        result = 'green'
      } else if (ratio > 1 && ratio <= 3) {
        result = 'yellow'
      } else {
        result = 'red'
      }
    }

    return result
  }

  state () {
    return [
      {
        title: '$vuetify.map.travelStats.averageSpeed.title',
        value: valueFormatted(this.averageSpeed),
        icon: mdiSpeedometer,
        postfix: '$vuetify.map.travelStats.averageSpeed.postfix',
        color: 'black'
      },
      {
        title: '$vuetify.map.travelStats.duration.title',
        value: this.durationLocalized,
        icon: mdiAlarm,
        color: 'black'
      },
      {
        title: '$vuetify.map.travelStats.maxSpeed.title',
        value: valueFormatted(this.maxSpeed),
        icon: mdiRocket,
        postfix: '$vuetify.map.travelStats.maxSpeed.postfix',
        color: 'black'
      },
      {
        title: '$vuetify.map.travelStats.maxAcceleration.title',
        value: valueFormatted(this.maxAcceleration),
        icon: mdiAxisArrow,
        postfix: '$vuetify.map.travelStats.maxAcceleration.postfix',
        color: 'black'
      },
      {
        title: '$vuetify.map.travelStats.distractionCount.title',
        value: this.distractionCount,
        icon: mdiKabaddi,
        color: 'red'
      },
      {
        title: '$vuetify.map.travelStats.drowsinessCount.title',
        value: this.drowsinessCount,
        icon: mdiSleep,
        color: 'purple'
      }
      // {
      //   title: '$vuetify.map.travelStats.distance.title',
      //   value: valueFormatted(this.distance),
      //   icon: mdiMapMarkerDistance,
      //   postfix: '$vuetify.map.travelStats.distance.postfix',
      //   color: 'black'
      // },

    ]
  }

  events () {
    return [
      {
        title: '$vuetify.map.travelStats.distractionCount.title',
        value: this.distractionCount,
        icon: mdiKabaddi,
        color: 'red'
      },
      {
        title: '$vuetify.map.travelStats.drowsinessCount.title',
        value: this.drowsinessCount,
        icon: mdiSleep,
        color: 'purple'
      }
    ]
  }
}
